export default {
  getHead: () => {
    return [{ name: "사업장명" }, { name: "소속명" }, { name: "부서명" }, { name: "TBM 실시일" }, { name: "작성자" }];
  },
  getCol: (index, value, func) => {
    switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1:
        return func.getContent(value).stdInfo.department; // 소속명
      case 2:
        return func.getContent(value).stdInfo.section; // 부서명
      case 3:
        return func.getContent(value).inputB_1; // TBM 실시일
      case 4:
        return value.user ? value.user.name : value.author.name; // 작성자
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "content$body.inputB_1";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
      case "사업장명":
        return ["content$body.field_name*%[:default_skw]%"];
      case "소속명":
        return ["content$body.stdInfo.department*%[:default_skw]%"];
      case "부서명":
        return ["content$body.stdInfo.section*%[:default_skw]%"];
      case "작성자":
        return ["content$body.stdInfo.writer_name*%[:default_skw]%"];
    }

    return [];
  },
};
